import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
  Button,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneTheater } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiActivity, FiDollarSign, FiPlus } from "react-icons/fi";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const theater: any = getOneTheater();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const theater_id = theater?.theater_id;
  const [thumbnail, setThumbnail] = useState<any>(theater?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(theater?.image_cdn_id);
  const [title, setTitle] = useState<any>(theater?.title);
  const [venue, setVenue] = useState<any>(theater?.venue);
  const [venueCapacity, setVenueCapacity] = useState<any>(theater?.venue_capacity);
  const [startDate, setStartDate] = useState<any>(theater?.start_date);
  const [endDate, setEndDate] = useState<any>(theater?.end_date);
  const [startTime, setStartTime] = useState<any>(theater?.start_time);
  const [endTime, setEndTime] = useState<any>(theater?.end_time);
  const [email, setEmail] = useState<any>(theater?.email_address);
  const [payLink, setPayLink] = useState<any>(theater?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(theater?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(theater?.whatsapp);
  const [facebook, setFacebook] = useState<any>(theater?.facebook);
  const [twitter, setTwitter] = useState<any>(theater?.twitter);
  const [instagram, setInstagram] = useState<any>(theater?.instagram);
  const [youtube, setYoutube] = useState<any>(theater?.youtube);
  const [hashtags, setHashtags] = useState<any>(theater?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(theater?.google_map_code);
  const [latitude, setLatitude] = useState<any>(theater?.latitude);
  const [longitude, setLongitude] = useState<any>(theater?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    theater?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(theater?.featured);
  const [promoted, setPromoted] = useState<any>(
    theater?.promoted ? theater?.promoted : "no"
  );
  const [theaterStatus, setTheaterStatus] = useState<any>(theater?.status);
  const [description, setDescription] = useState<any>(theater?.description);
  const [expo, setExpo] = useState<any>(theater?.expo);
  const [pricing, setPricing] = useState<any>(theater?.Pricings);

  const [showModal, setShowModal] = useState(false);
  const [collection, setCollection] = useState<any>(
    theater?.WhatIsArounds ? theater?.WhatIsArounds : []
  );
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const theaterRoutes = "/data/theater";

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneTheaterHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : theater?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title ? title.toLowerCase().replace(/\s/g, "_") : null,
      description: description,
      venue: venue,
      venue_capacity: venueCapacity,
      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_adv: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: theaterStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      pricing: pricing,
      subdata: collection?.length > 0 ? collection : [],
    };

    const { message, status } = await updateOneContent({
      data_id: theater_id,
      data: data,
      content: _TYPES_.THEATER,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={theaterRoutes}
      eyebrow="DoSee Data • Theaters"
      title="Edit Theater"
      subtitle={`Update a theater venue in ${entry_label || "this destination"}.`}
      icon={<FiActivity className="h-5 w-5" />}
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneTheaterHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="Stage, marquee or production photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.THEATERS)}
        />
      </AddSection>

      <AddSection title="Theater Details" hint="Title, venue and capacity.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue_capacity",
              title: "Venue Capacity",
              type: "number",
              value: venueCapacity || "",
              onChange: (e: any) => {
                setVenueCapacity(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Performance schedule."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "start_date",
              title: "Start Date",
              type: "date",
              value: startDate || "",
              onChange: (e: any) => {
                setStartDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_date",
              title: "End Date",
              type: "date",
              value: endDate || "",
              onChange: (e: any) => {
                setEndDate(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "start_time",
              title: "Start Time",
              type: "time",
              value: startTime || "",
              onChange: (e: any) => {
                setStartTime(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "end_time",
              title: "End Time",
              type: "time",
              value: endTime || "",
              onChange: (e: any) => {
                setEndTime(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="theater_status"
        setStatus={setTheaterStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={theaterStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Additional Details"
        hint="Optional sub-collections like productions or seasons."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <Button
          props={{
            type: "button",
            title: "Add More Details",
            category: "default",
            action: "add",
            onClick: () => setShowModal(true),
          }}
        />
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
